import {defineStore} from 'pinia'
import {Helpers} from '@/helpers'
import {saveAs} from 'file-saver'

export const useGeneralTermStore = defineStore({
    id: 'general_term',
    state: () => ({
        general_terms: [],
        allGeneralTerms: [],
        general_term: null,
        lockedGeneralTerms: [],
        renderedPdf: null,
        renderedPdfMeta: null,
        itemLength: 0,
        loading: false,
        serverOptions: {
            page: 0,
            rows: 10,
            sortBy: 'key',
            sortType: 'asc',
        }
    }),
    getters: {},
    actions: {
        index() {
            this.loading = true
            const params = {
                page: this.serverOptions.page + 1,
                size: this.serverOptions.rows
            }
            return this.apiClient.get('/general_terms', {params}).then(({data}) => {
                this.general_terms = data.general_terms
                this.itemLength = data.itemLength
                this.loading = false
            }).catch((error) => {
                this.loading = false
                throw error
            })
        },
        indexLocked() {
            return this.apiClient.get('/general_terms', {params: {locked: true, size: 1000}}).then(({data}) => {
                this.lockedGeneralTerms = data.general_terms
                return {data}
            })
        },
        indexAll() {
            return this.apiClient.get('/general_terms', {params: {size: 1000}}).then(({data}) => {
                this.allGeneralTerms = data.general_terms
                return {data}
            })
        },
        show(id) {
            return this.apiClient.get(`/general_terms/${id}`).then(({data}) => {
                this.general_term = data.general_term
                this.setRenderedPdf(data.rendered_pdf)
                return {data}
            })
        },
        setRenderedPdf(renderedPdf) {
            if (!renderedPdf?.blob) {
                this.renderedPdf = null
                this.renderedPdfMeta = null
                return
            }
            this.renderedPdf = Helpers.base64ToBlob(renderedPdf)
            this.renderedPdfMeta = {
                filename: renderedPdf.filename,
                type: renderedPdf.type,
            }
        },
        downloadPdf() {
            if (!this.renderedPdf) {
                return
            }
            const filename = this.renderedPdfMeta?.filename
                || `${this.general_term?.key || 'general_term'}.pdf`
            saveAs(this.renderedPdf, filename)
        },
        create(general_term) {
            return this.apiClient.post('/general_terms', {general_term})
        },
        update(id, general_term) {
            return this.apiClient.put(`/general_terms/${id}`, {general_term}).then(({data}) => {
                if (data.general_term) {
                    this.general_term = data.general_term
                }
                return {data}
            })
        },
        lock(id) {
            return this.apiClient.put(`/general_terms/${id}/lock`).then(({data}) => {
                if (data.general_term) {
                    this.general_term = data.general_term
                }
                return {data}
            })
        },
    },
})
